// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"835b3e94","357":"fe26bd85"}[chunkId] + ".css";
};